import Vue from 'vue';
import Vuex from 'vuex';

import modules from './modules';
import {doLogin} from '../lib/controller-api';
import {processOperatorToken} from '../lib/data-processing';
import {_names as M} from './mutation-types';

import VideoPlugin from './plugins/controller-websocket';

Vue.use(Vuex);

const store = new Vuex.Store({
	modules,
	state: {
		showLoader: 0,
		errorMessage: undefined,
		errorTitle: 'Error',

		controller: undefined,
		callerId: undefined,

		profile: {},
	},
	actions: {
		doLogin,
		processOperatorToken,
	},
	mutations: {
		[M.SHOW_LOADER](state) {
			state.showLoader++;
		},
		[M.HIDE_LOADER](state) {
			if (state.showLoader > 0) {
				state.showLoader--;
			}
		},
		[M.SET_ERROR](state, message) {
			state.errorMessage = message;
		},
		[M.SET_ERROR_TITLE](state, message) {
			if (message) {
				state.errorTitle = message;
			} else {
				state.errorTitle = 'Error';
			}
		},
		[M.SET_INITIAL_DATA](state, data) {
			// Ensure trailing slash
			if (!data.iss.endsWith('/')) {
				data.iss += '/';
			}
			state.controller = data.iss;
			state.callerId = data.sub;

			VideoPlugin(this);
		},
		[M.UPDATE_PROFILE](state, data) {
			state.profile = data;
		}
	},
	getters: {
		isLoggedIn(state) {
			return !! state.operator.rawToken;
		},
		showLoader(state) {
			return !! state.showLoader;
		},
		showError(state) {
			return !! state.errorMessage;
		},

	}
});

export default store;
